<script>
import logotype from '../../assets/logo/logotype.png'

/**
 * Minimal header of a standalone applet: the ARTup logotype, the title of the applet
 * and a LOG OUT button. When applets run embedded in the ARTup Platform wrapper
 * the decorations come from the wrapper, so the header is meant for standalone use only.
 */
export default {
  props: {
    // Title of the applet, displayed next to the logo
    title: {
      type: String,
      default: ''
    },
    // Active session. The LOG OUT button is visible only when a session is present
    session: {
      default: null
    },
    // Height of the logo in pixels, the title font scales with it
    logoHeight: {
      type: Number,
      default: 56
    }
  },

  emits: [
    'logout'
  ],

  data () {
    return {
      // ARTup logotype
      logotype
    }
  },

  computed: {
    // Log out button is visible only when a session is present
    canLogout () {
      return Boolean(this.session)
    },

    // CSS variables driving the proportions of the header
    style () {
      return {
        '--logo-height': `${this.logoHeight}px`
      }
    }
  },

  methods: {
    // Notifies about the request to log out
    logout () {
      this.$emit('logout')
    }
  }
}
</script>

<template>
  <header class="artup-applet-header" :style="style">
    <img class="logotype" :src="logotype" alt="ARTup">
    <span v-if="title" class="title">
      {{ title }}
    </span>
    <slot></slot>
    <q-space></q-space>
    <slot name="actions"></slot>
    <q-btn v-if="canLogout" label="Log Out" icon="logout" flat no-caps color="grey-8" class="logout"
      @click="logout()">
    </q-btn>
  </header>
</template>

<style lang="scss" scoped>
.artup-applet-header {
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-bottom: solid #0000001f 1px;
  background-color: white;

  .logotype {
    // The logotype file has a safe area around the letters, so the letters
    // themselves take up roughly 45% of the image height
    height: var(--logo-height);
    // Compensate for the safe area on the left, so that the letters align with the padding
    margin-left: calc(var(--logo-height) * -0.28);
    margin-right: calc(var(--logo-height) * -0.2);
  }

  .title {
    // Same height and colour as the ART part of the logotype
    font-size: calc(var(--logo-height) * 0.44);
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.02em;
    color: black;
    white-space: nowrap;
  }
}

/* Layout adjustments for mobile screens */
@media screen and (max-width: 640px) {
  .artup-applet-header {
    padding: 4px 8px;

    .title {
      font-size: calc(var(--logo-height) * 0.34);
    }
  }
}
</style>
